import {
  KeyCodes,
  KeyEventType,
  priorityQueueListeners,
  VirtualKeys,
  Priority,
  KeyGroups,
} from '@accedo/virtual-key';
import { logger } from '@accedo/logger';
import { nav } from '##/init';
import { PageNavigation } from '##/utils/PageNavigation';
import {
  clearScreenLogger,
  launchFreeviewApp,
  toggleScreenLogger,
  exitApp,
} from '##/utils';

type ListenerFn = (
  keyName: VirtualKeys,
  eventType?: KeyEventType,
) => boolean | void;

const isNotPlaying = (): boolean =>
  !window.location.pathname.includes('/player');

class KeyEventHelper {
  private globalKeyListenerId = 'onGlobalKey';
  private globalBackKeyListenerId = 'onGlobalBackKey';
  private listenerTracker: string[] = [];

  init = (): void => {
    priorityQueueListeners.enqueue(
      async (keyName: VirtualKeys) => {
        if (keyName === KeyCodes.vKey.KEY_1) {
          toggleScreenLogger();
        }

        if (keyName === KeyCodes.vKey.KEY_5) {
          clearScreenLogger();
        }

        if (keyName === KeyCodes.vKey.RED && isNotPlaying()) {
          exitApp();

          return;
        }

        if (keyName === KeyCodes.vKey.GREEN && isNotPlaying()) {
          launchFreeviewApp();

          return;
        }

        if (keyName === KeyCodes.vKey.BACK) {
          PageNavigation.handleGlobalBackKey();
        }
      },
      Priority.LOWER,
      this.globalBackKeyListenerId,
    );

    // Spatial Navigation
    priorityQueueListeners.enqueue(
      async (keyName: VirtualKeys) => nav.onKeyEvent(keyName),
      Priority.LOWEST,
      this.globalKeyListenerId,
    );
  };

  addKeydownListener = (
    action: ListenerFn,
    listenerId: string,
    priority: Priority = Priority.NORMAL,
    listenOn?: KeyGroups,
    longPressKeys?: VirtualKeys[],
  ): void => {
    const asyncAction = async (
      keyName: VirtualKeys,
      eventType: KeyEventType,
    ): Promise<boolean | void> => action(keyName, eventType);

    if (this.listenerTracker.includes(listenerId)) {
      logger.warn('Keydown listener id already added');
    }
    priorityQueueListeners.enqueue(
      asyncAction,
      priority,
      listenerId,
      listenOn || undefined,
      longPressKeys || [],
    );
    this.listenerTracker.push(listenerId);
  };

  removeKeydownListener = (listenerId: string): void => {
    this.listenerTracker = this.listenerTracker.filter(
      (id) => id !== listenerId,
    );
    priorityQueueListeners.removeListenerById(listenerId);
  };
}

export default new KeyEventHelper();
